export const LOGIN_API = "user/login";

export const USERS = "user";

export const ROLES = "role";

export const VEHICLE = "vehicle";

export const VEHICLE_TYPE = "vehicle_type";

export const UPLOAD_STATE_VILLAGE_CSV = "upload_state_village_csv";

export const STATES = "states";

export const DISTRICTS = "districts";

export const VILLAGES = "villages";

export const PROJECT_VILLAGES = "project/project_villages";

export const EQUIPMENT_TYPE = "equipment_type";

export const EQUIPMENT = "equipment";

export const FINDEQUIPMENT = "equipment/findEquipment";

export const PROJECT = "project";

export const DRIVER_TYPES = "driver_type";

export const TEAMS = "teams";

export const ASSIGN_VILLAGES = "project/reassign_villages";

export const ADD_FIELD_SUPER_VISOR = "project/add_field_supervisor";

export const ADD_VILLAGES = "project/add_villages";

export const USERNAME_UNIQUE_CHECK = "user/username_unique_check";

export const ASSIGN_SECTOR_OFFICER = "project/assign_sector_officers";

export const FARMS = "farmer";

export const FARMERS = "farmer";

export const GET_FARMS = "farmer/getFarms";

export const GET_SUPERVISOR_FOR_TEAM = "teams/supervisors";

export const ASSIGN_FARMER_TO_RAKE_TEAM = "teams/assign_farmer_to_rake_team";

export const ASSIGN_FARMER_TO_BAILER_TEAM =
  "teams/assign_farmer_to_bailer_team";

export const ASSIGNABLE_FARMER_TO_SUB_TEAM = "assignable_farmer_to_sub_team";

export const ASSIGN_FARMS = "teams/assign_farmer";
export const ASSIGN_FARMERS_TO_SUB_TEAM = "teams/assign_farmers_to_sub_team";
export const ASSIGN_FARM_TO_SUB_TEAM = "teams/assign_farms_to_sub_team";
export const SUB_DISTRICTS = "sub_districts";

export const GET_USER_DAY_STATUS = "user/get_user_day_status";

export const PROJECT_MIS = "project/mis";
export const ATTANDENCEREPORT = "attandenceReport";

export const CREATE_SUB_TEAM = "teams/create_sub_team";

export const ASSIGNED_FARMER_TO_SUB_TEAM = "assigned_farmer_to_sub_team";

export const DIESEL_SUPERVISOR = "diesel_supervisor";

export const STORAGE_SUPERVISOR = "storage_supervisor";

export const REASSIGN_SUB_TEAM = "teams/reassign_sub_team";

export const TASKS = "tasks";

export const FETCH_DASHBOARD_DETAIL = "fetch_Dashboard_Detail";
export const FETCH_TEAM_DASHBOARD_DETAIL = "fetch_Team_Dashboard_Detail";
